import { Link } from 'react-router-dom';
import { Layout } from '@/components/layout';
import { EmptyState, Button } from '@/components/atoms';

export function NotFoundPage(): JSX.Element {
  return (
    <Layout title="">
      <EmptyState
        icon="sad"
        title="404"
        message="Цієї сторінки немає. Або була — і пішла."
        actions={
          <Link to="/">
            <Button>На головну</Button>
          </Link>
        }
      />
    </Layout>
  );
}
